module.exports = __webpack_public_path__ + "img/logo.0114eff0.svg";